import axios from 'axios'

export const getDiscounts = (partnerId: string) => {
  return axios.get('/data/atlaide?sadarbības_partneris_id=' + partnerId).then((resp) => resp.data)
}
